<div class="lp-solid-color-canvas-component" style="width: 100%; height: 100%" [style.background-color]="color()"></div>
